import { ScanToOrderCartItem } from "./scanToOrderCartItem/scanToOrderCartItem";
import { RetailCartValue } from "@/dto/retailCartValue";

export interface AlreadySentToKitchenSectionProps {
  items: RetailCartValue[];
  onRequestClose: () => void;
}

export const AlreadySentToKitchenSection = ({
  items,
  onRequestClose,
}: AlreadySentToKitchenSectionProps) => {
  return (
    <div className="pt-12 mx-4">
      <p className="text-[15px] text-[#727272] font-medium">
        Already sent to kitchen:
      </p>
      {items?.map((item: RetailCartValue, index: number) => (
        <ScanToOrderCartItem
          key={index}
          index={index}
          item={item}
          onRequestClose={onRequestClose}
        />
      ))}
    </div>
  );
};
